import { digObject, sortArrayBy } from 'functions/utilities'

export function isAdmin(roleTitle){
  const titles = ['Admin', 'Support']
  return titles.includes(roleTitle)
}

export function isAgencyAdmin(roleTitle){
  const titles = ['Office Director', 'Office Administrator']
  return titles.includes(roleTitle)
}

export function isAgent(roleTitle){
  const titles = ['Agent', 'Personal Assistant']
  return titles.includes(roleTitle)
}

export function isAgencyUser(roleTitle){
  return isAgencyAdmin(roleTitle) || isAgent(roleTitle)
}

export function isProvider(roleTitle){
  const titles = ['Provider Director', 'Provider Employee', 'Provider Contractor']
  return titles.includes(roleTitle)
}

export function isBrandUser(roleTitle){
  const titles = ['Brand Administrator']
  return titles.includes(roleTitle)
}

export function agentUsers(users){
  const userArray = Object.values(users)

  return userArray.filter(user => user.actable_type === 'Agent')
}

export function providerEmployeeUsers(users){
  const userArray = Object.values(users)

  return userArray.filter(user => user.actable_type === 'ProviderEmployee')
}

export function contentEditorUsers(users){
  const filtered = Object.values(users).filter((user) => {
    const contentEditor = digObject(user, 'options.content_editor', false)
    return contentEditor && user.actable_type === 'ProviderEmployee'
  })

  return sortArrayBy(filtered, 'asc', 'full_name')
}

export function isMasterAdmin(roleTitle){
  const titles = ['Admin']
  return titles.includes(roleTitle)
}

export const notificationTypes = {
  email: {
    artwork: [
      {
        editable: true,
        key: 'artwork_commented_email',
        title: 'New Comment',
        user_types: ['Agent', 'OfficeAdministrator'],
      },
      {
        editable: true,
        key: 'artwork_reviewed_email',
        title: 'New Review',
        user_types: ['Agent', 'OfficeAdministrator'],
      },
    ],
    bookings: [
      {
        editable: true,
        key: 'booking_created_email',
        title: 'Created',
        user_types: ['Agent', 'OfficeAdministrator'],
      },
      {
        editable: true,
        key: 'booking_updated_email',
        title: 'Updated',
        user_types: ['Agent', 'OfficeAdministrator'],
      },
      {
        editable: true,
        key: 'booking_cancelled_email',
        title: 'Cancelled',
        user_types: ['Agent', 'OfficeAdministrator'],
      },
    ],
    conversations: [
      {
        editable: true,
        key: 'new_conversation_comment',
        title: 'New Comment',
        user_types: ['Agent', 'OfficeAdministrator'],
      },
    ],
    digital_pages: [
      {
        editable: true,
        key: 'response_submitted',
        title: 'Response Submitted',
        user_types: ['Agent', 'OfficeAdministrator'],
      },
    ],
    orders: [
      {
        editable: true,
        key: 'order_confirmation_email',
        title: 'Confirmation',
        user_types: ['Agent', 'OfficeAdministrator'],
      },
      {
        editable: true,
        key: 'order_item_dispatched_email',
        title: 'Dispatched',
        user_types: ['Agent'],
      },
    ],
    proposals: [
      {
        title: 'Acceptance',
        user_types: ['Agent', 'OfficeAdministrator'],
        key: 'proposal_accepted',
        editable: true,
      },
    ],
    tasks: [
      {
        editable: true,
        key: 'task_completion_email',
        title: 'Complete',
        user_types: ['Agent', 'OfficeAdministrator'],
      },
    ],
    other: [
      {
        title: 'Enquiry',
        user_types: ['Agent', 'OfficeAdministrator'],
        key: 'user_enquiry_email',
        editable: true,
      },
    ],
  },
}

export default isAdmin
